module.exports = __webpack_public_path__ + "media/images/question_examples/question-example-multi-image-fb26be78bc4938b277c401141d4e4e25.png";